import { render } from "./timeBtn.vue?vue&type=template&id=95d0b31c&scoped=true"
import script from "./timeBtn.vue?vue&type=script&lang=js"
export * from "./timeBtn.vue?vue&type=script&lang=js"

import "./timeBtn.vue?vue&type=style&index=0&id=95d0b31c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95d0b31c"]])

export default __exports__